<template>
    <layout v-cloak>
	   <div class="row">
            <div class="col-sm-12">
                <form autocomplete="off" method="post" data-vv-scope="form" @submit.prevent="saveItem">
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="text"
                                    class="city-form-group city-bg"
                                    id="input-url"
                                    name="url"
                                    v-model.trim="form.url"
                                    v-validate="{required: true, url: {require_protocol: true }}"
                                    :inputClasses="[{'is-invalid': fnHasError('url') }]"
                                    :error="fnFirstError('url')">
                                    {{ $t(`${pageID}.model.url`) }}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="form.id!=null"
                                    class="city-form-group city-bg"
                                    id="input-ogc_service_id"
                                    name="ogc_service_id"
                                    label="code"
                                    :filterable="true"
                                    :options="lists.ogcservices"
                                    v-model.trim="form.ogc_service_id"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('ogc_service_id') }]"
                                    :error="fnFirstError('ogc_service_id')">
                                    {{ $t(`${pageID}.model.type`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-use_proxy"
                                    name="use_proxy"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.onoff"
                                    :reduce="option => option.code"
                                    v-model.trim="form.use_proxy"
                                    v-validate="rulesProxy"
                                    :inputClasses="[{'is-invalid': fnHasError('use_proxy') }]"
                                    :error="fnFirstError('use_proxy')"
                                    :helpText="`${pageID}.help.use_proxy`">
                                    {{ $t(`${pageID}.model.use_proxy`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <MaterialSelect
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-is_private"
                                    name="is_private"
                                    label="name"
                                    :filterable="true"
                                    :options="lists.onoff"
                                    :reduce="option => option.code"
                                    v-model.trim="form.is_private"
                                    v-validate="'required'"
                                    :inputClasses="[{'is-invalid': fnHasError('is_private') }]"
                                    :error="fnFirstError('is_private')"
                                    :helpText="`${pageID}.help.is_private`">
                                    {{ $t(`${pageID}.model.is_private`) }}
                                </MaterialSelect>
                            </div>
                        </div>
                    </div>
                    <div v-if="form.id">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg"
                                        id="input-title"
                                        name="title"
                                        v-model.trim="form.title"
                                        v-validate="'required|min:3'"
                                        :inputClasses="[{'is-invalid': fnHasError('title') }]"
                                        :error="fnFirstError('title')">
                                        {{ $t(`${pageID}.model.title`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialTextarea
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg mb-0"
                                        id="input-description"
                                        name="description"
                                        v-model.trim="form.description"
                                        :rows="4"
                                        v-validate="''"
                                        :inputClasses="[{'is-invalid': fnHasError('description') }]"
                                        :error="fnFirstError('description')">
                                        {{ $t(`${pageID}.model.description`) }}
                                    </MaterialTextarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialTextarea
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg mb-0"
                                        id="input-abstract"
                                        name="abstract"
                                        v-model.trim="form.abstract"
                                        :rows="4"
                                        v-validate="''"
                                        :inputClasses="[{'is-invalid': fnHasError('abstract') }]"
                                        :error="fnFirstError('abstract')">
                                        {{ $t(`${pageID}.model.abstract`) }}
                                    </MaterialTextarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group city-form-group city-bg">
                                    <MaterialInput
                                        :readonly="readonlyFormItem"
                                        :disabled="readonlyFormItem"
                                        class="city-form-group city-bg"
                                        id="input-keywords"
                                        name="keywords"
                                        v-model.trim="form.keywords"
                                        v-validate="''"
                                        :inputClasses="[{'is-invalid': fnHasError('keywords') }]"
                                        :error="fnFirstError('keywords')">
                                        {{ $t(`${pageID}.model.keywords`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="mt-1">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    class="city-form-group city-bg"
                                    id="input-username"
                                    name="username"
                                    v-model.trim="form.username"
                                    v-validate="'min:3'"
                                    :inputClasses="[{'is-invalid': fnHasError('username') }]"
                                    :error="fnFirstError('username')">
                                    {{ $t(`${pageID}.model.username`) }}
                                </MaterialInput>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <MaterialInput
                                    :readonly="readonlyFormItem"
                                    :disabled="readonlyFormItem"
                                    type="password"
                                    class="city-form-group city-bg"
                                    id="input-password"
                                    name="password"
                                    v-model.trim="form.password"
                                    v-validate="rulesPassword"
                                    :inputClasses="[{'is-invalid': fnHasError('password') }]"
                                    :error="fnFirstError('password')">
                                    {{ $t(`${pageID}.model.password`) }}
                                </MaterialInput>
                            </div>
                        </div>
                    </div>
                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="saveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
            </div>
    	</div>
    </layout>
</template>

<script>
	import GeneralMixin     from './../../mixin';

    export default {
        mixins: [
            GeneralMixin,
        ],
        components: {
        },
    	data() {
      		return {
      			pageID: 'ogc_remote_services',
                lists: {
                    ogcservices: [],
                },
                form: {
                    id: null,
                    url: null,
                    use_proxy: 0,
                    is_private: 0,
                    ogc_service_id: null,
                    title: null,
                    description: null,
                    abstract: null,
                    keywords: null,
                    username: null,
                    password: null,
                },
      		}
    	},
        computed: {
            rulesPassword() {
                return {
                    required: !!this.form.username,
                    min: 3
                };
            },
            rulesProxy() {
                return {
                    required: true,
                    is: !!this.form.username ? this.lists.onoff[0].code : this.form.use_proxy,
                };
            },
        },
        mounted() {
            this.loadLists();
        },
    	methods: {
    	}
  	}
</script>

